"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const immer_1 = tslib_1.__importDefault(require("immer"));
const changeDueDateOfEnrolment_1 = tslib_1.__importDefault(require("../../helpers/enrolment/changeDueDateOfEnrolment"));
const getDueDate_1 = require("../../helpers/enrolment/getDueDate");
const getEnrolmentOfContent_1 = tslib_1.__importDefault(require("../../helpers/enrolment/getEnrolmentOfContent"));
const updateEnrolmentFields_1 = require("../../helpers/enrolment/updateEnrolmentFields");
const getDueDateChangedEvent_1 = require("../../helpers/getEvent/getDueDateChangedEvent");
function changeDueDate(command, user, content, enrolments) {
    try {
        const events = [];
        const updatedEnrolments = immer_1.default(enrolments, draftEnrolments => {
            const enrolment = getEnrolmentOfContent_1.default(draftEnrolments, content._id, user.userId);
            if (enrolment) {
                const previousDueDate = getDueDate_1.getDueDateOfEnrolment(enrolment);
                changeDueDateOfEnrolment_1.default(command, content, enrolment);
                const updatedDueDate = getDueDate_1.getDueDateOfEnrolment(enrolment);
                const dueDateChangedEvent = getDueDateChangedEvent_1.getDueDateChangedEvent(command, user, content, previousDueDate, updatedDueDate);
                updateEnrolmentFields_1.updateDates(command, enrolment);
                events.push(dueDateChangedEvent);
            }
        });
        return { enrolments: updatedEnrolments, events, states: [], stateInteractions: [] };
    }
    catch (error) {
        throw new Error('Error in changeDueDate ' + error);
    }
}
exports.default = changeDueDate;
//# sourceMappingURL=changeDueDate.js.map